import { useState } from "react"
import { Box, Field, Input, Textarea } from "@chakra-ui/react"
import useStore from "../../../store"
import { HappyButton, NeutralButton } from "../../common/Buttons"
import Spinner from "../../common/Spinner"
import { colors } from "../../../utilities/colors"

export default function UnitNoteForm({ unitId, onClose }) {
  const createUnitNote = useStore((state) => state.createUnitNote)
  const isCreatingUnitNote = useStore((state) => state.isCreatingUnitNote)

  const [subject, setSubject] = useState("")
  const [note, setNote] = useState("")

  const handleSubmit = async () => {
    await createUnitNote(unitId, { subject, note })
    onClose()
  }

  return (
    <Box as="form" mt={2}>
      <Field.Root id="subject" mb={4}>
        <Field.Label fontSize="sm" color={colors.grey300} htmlFor="subject">
          Subject
        </Field.Label>
        <Input
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          bgColor={colors.grey900}
          _focus={{ borderColor: colors.grey100, ringColor: colors.grey100 }}
        />
      </Field.Root>
      <Field.Root id="note" mb={4}>
        <Field.Label fontSize="sm" color={colors.grey300} htmlFor="note">
          Note
        </Field.Label>
        <Textarea
          value={note}
          onChange={(e) => setNote(e.target.value)}
          bgColor={colors.grey900}
          _focus={{ borderColor: colors.grey100, ringColor: colors.grey100 }}
        />
      </Field.Root>
      <div className="flex justify-evenly items-center">
        {isCreatingUnitNote ? (
          <Spinner color="green" />
        ) : (
          <>
            <HappyButton
              text="Submit"
              onClick={handleSubmit}
              style="my-4 w-30 justify-items-center"
            />
            <NeutralButton
              text="Cancel"
              onClick={onClose}
              style="my-4 w-30 justify-items-center"
            />
          </>
        )}
      </div>
    </Box>
  )
}
